import { useMemo } from 'react';
import { PersonFormState } from 'shared/data/walletsKyc/v1';

import { useKycData } from '../../../resources/hooks/useKycData';

export const useIsSubmitAvailable = () => {
    const { data } = useKycData();

    const isSubmitAvailable = useMemo(
        () =>
            data?.data?.people?.persons
                ? data.data.people.persons.every((person) => person.personFormState === PersonFormState.Ready)
                : false,
        [data?.data?.people?.persons]
    );

    return { isSubmitAvailable };
};
